import { StartClient } from '@tanstack/react-start/client'
import { StrictMode, startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { loadDict, localeFromPathname } from './i18n'

// 表示する言語の辞書を読み込んでから、サーバーが描いた画面を引き継ぐ
loadDict(localeFromPathname(location.pathname)).then(() => {
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <StartClient />
      </StrictMode>,
    )
  })
})
